module.exports = __webpack_public_path__ + "img/people-sightseeing-outdoors-rafiki.1987a745.svg";